<mat-card appearance="outlined" class="chart" telemetry="Card-PrepaidBillingChart-UtilityBilling">
    <mat-card-header fxLayoutAlign="space-between start">
        <mat-card-title>Prepaid Billing</mat-card-title>

        <button mat-icon-button (click)="displayChartParameterDialogAndReload()">
            <mat-icon fontIcon="settings" fontSet="material-icons">
            </mat-icon>
        </button>
    </mat-card-header>

    <mat-card-content>
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>

            <div *ngIf="errorMessage" class="error-red">
                {{errorMessage}}
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </mat-card-content>
</mat-card>
